import { render, staticRenderFns } from "./ClinicLogoutModal.vue?vue&type=template&id=00fb352c&scoped=true"
import script from "./ClinicLogoutModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicLogoutModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ClinicLogoutModal.vue?vue&type=style&index=0&id=00fb352c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fb352c",
  null
  
)

export default component.exports